import { render, staticRenderFns } from "./s3-8.vue?vue&type=template&id=3467c715&scoped=true&"
import script from "./s3-8.vue?vue&type=script&lang=js&"
export * from "./s3-8.vue?vue&type=script&lang=js&"
import style0 from "./s3-8.vue?vue&type=style&index=0&id=3467c715&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3467c715",
  null
  
)

export default component.exports